export default __webpack_public_path__ + "static/angle-652192fd27e0afa68476cc13118f2652.png";